// extracted by mini-css-extract-plugin
module.exports = {"root":"AnimatedTreeBlock_root__zzsZg"};